<template>
  <div class="convention-hall page">
    <!-- 头部卡片：页面标题 + 功能小标签 + 数据统计展示 -->
    <div class="bc-top">
      <div class="bc-top2">
        <div class="font">{{ $t("concubine.Featured") }}</div>
        <!-- <div class="font">{{ $t("concubine.Checklist") }}</div> -->
      </div>
      <!-- 页面主标题 -->
      <div style="color: #fff; font-size: 1.4rem">
        {{ $t("concubine.concubine") }}
      </div>
      <!-- 副标题提示：切换城市 -->
      <div
        style="
          color: #fff;
          font-size: 0.6rem;
          width: 42vw;
          font-weight: lighter !important;
          margin-bottom: 0.5rem;
        "
      >
        {{ $t("concubine.switch_city") }}
      </div>

      <!-- 数据统计模块：展示服务数量、完成状态 -->
      <div class="bc-state">
        <div class="state">
          <div style="color: #feb974; font-weight: lighter !important">
            {{ $t("concubine.Serve") }}
          </div>
          <div style="font-size: 1.2rem">{{ addlist.length }}</div>
          <div style="color: #ccc; font-weight: lighter !important">
            {{ $t("concubine.Serve") }}
          </div>
        </div>
        <div class="state">
          <div style="color: #feb974; font-weight: lighter !important">
            {{ $t("concubine.information") }}
          </div>
          <div style="font-size: 1.2rem">{{ datalist.length}}</div>
          <div style="color: #ccc; font-weight: lighter !important">
            {{ $t("concubine.beautiful") }}
          </div>
        </div>
      </div>
    </div>

    <!-- 热门标题区域：展示热门标题 -->
    <div class="bc-hot">
      <div class="hot-title">{{ $t("concubine.Urban") }}</div>
      <div>{{ $t("concubine.consort") }}</div>
    </div>

    <!-- ====================== 地区选择导航栏 ====================== -->
    <div class="address-tab-wrap">
      <div
        class="address-tab-item"
        v-for="(val, key) in addlist"
        :key="key"
        :class="{ active: chooseActive.id === val.id }"
        @click="addgo(val)"
      >
        {{ val.name }}
      </div>
    </div>

    <!-- ====================== 下拉刷新 + 人员列表 ====================== -->
    <van-pull-refresh
      :pulling-text="$t('reservation.refresh')"
      :loosing-text="$t('reservation.refreshpage')"
      :loading-text="$t('reservation.refresh')"
      :success-text="$t('reservation.refresh')"
      border="false"
      class="list-wrapper"
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <!-- 人员列表项：点击进入详情 -->
      <div
        class="movie-item m-flex"
        @click="profile(v.id)"
        v-for="(v, k) in datalist"
        :key="k"
      >
        <!-- 人员头像 -->
        <van-image class="movie-img" round lazy-load :src=" v.img_url">
          <template v-slot:loading>
            <van-loading type="circular" />
          </template>
        </van-image>
        <!-- 人员名称 -->
        <div class="m-f1 m-md2-l bc-flex">
          <div
            style="
              display: flex;
              justify-content: space-between;
              width: 100%;
              align-items: center;
              height: 2rem;
            "
          >
            <p>{{ v.xuanfei_name || $t("No information yet") }}</p>
            <div class="renzheng">
              <img src="../../assets/bc-img/V.png" alt="" />
              <div>{{ $t("index.Certification") }}</div>
            </div>
          </div>
          <!-- <div class="miaoshu" ><p>玛利西亚{{$t('concubine.lady')}}</p></div> -->
          <div class="shoufei" ><van-rate v-model="v.fee_star" size="15px" color="#FFD21D"/></div>
          <div class="shoufei" ><p>{{$t('concubine.height')}}</p><p class="shoufei">{{ v.height }} </p><p>{{$t('concubine.chest')}}</p>{{ v. bust}}</div>
          <div class="bc-btn">{{ $t('concubine.Make') }}</div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 加载更多按钮：数据满10条显示，点击加载下一页 -->
    <div class="next" v-if="datalist.length >= 10" @click="nextList()">
      {{ $t("index.next") }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Choose',
  data() {
    return {
      addlist: [], // 城市/地区列表数据
      chooseActive: {}, // 当前选中的城市对象（控制高亮）
      address_show: false, // 旧版地区弹窗开关（未使用）
      vod_name: "", // 备用字段
      isLoading: false, // 下拉刷新 loading 状态
      datalist: [], // 人员列表数据
      choose_page: 1, // 分页页码（默认第1页）,
      value:3,
    };
  },
  methods: {
    regionNames() {
      return ["台灣", "馬來西亞", "新加坡", "泰國"];
    },
    normalizeAddressList(list) {
      const names = this.regionNames();
      return (Array.isArray(list) ? list : []).slice(0, names.length).map((item, index) => ({
        ...item,
        name: names[index],
      }));
    },
    applyCachedChooseData() {
      const cache = localStorage.getItem("choose_page_cache");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.addlist = this.normalizeAddressList(parsed.addlist);
        this.chooseActive = parsed.chooseActive || {};
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        const active = this.addlist.find((item) => item.id === this.chooseActive.id);
        if (active) {
          this.chooseActive = active;
        }
        return this.addlist.length > 0 || this.datalist.length > 0;
      } catch (error) {
        return false;
      }
    },
    persistChooseData() {
      localStorage.setItem(
        "choose_page_cache",
        JSON.stringify({
          addlist: this.addlist,
          chooseActive: this.chooseActive,
          datalist: this.datalist,
        })
      );
    },
    /**
     * 加载更多
     * 功能：页码+1，请求下一页人员数据
     */
    nextList() {
      this.choose_page += 1;
      this.getxuanfeilist();
    },

    /**
     * 下拉刷新
     * 功能：清空列表 → 重置页码 → 重新请求第一页
     */
    onRefresh() {
      this.datalist = [];
      this.choose_page = 1;
      this.getxuanfeilist().finally(() => {
        this.isLoading = false;
      });
    },

    /**
     * 获取人员列表
     * 接口：xuanfeilist
     * 参数：page 页码、adsid 城市ID
     */
    getxuanfeilist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          page: this.choose_page,
          class_id: this.chooseActive.id,
          // plain_json:1
        },
      }).then((res) => {
        const list = Array.isArray(res.data.list) ? res.data.list : [];
        if (list.length > 0) {
          if (this.choose_page === 1) {
            this.datalist = list;
          } else {
            const currentIds = new Set(this.datalist.map((item) => item.id));
            const nextItems = list.filter((item) => !currentIds.has(item.id));
            this.datalist.push(...nextItems);
          }
          this.persistChooseData();
        } else {
          if (this.choose_page > 1) this.choose_page -= 1;
        }
      });
    },

    /**
     * 跳转人员详情页
     * @param {Number} id 人员ID
     */
    profile(id) {
      this.$router.push({
        path:
          "/profile?id=" +
          id +
          "&name=" +
          this.chooseActive.name +
          "&adsid=" +
          this.chooseActive.id,
      });
    },

    /**
     * 切换城市（核心功能）
     * @param {Object} data 选中的城市对象
     * 功能：切换城市 → 清空列表 → 重置页码 → 请求新数据
     */
    
    addgo(data) {
      // 未登录则跳转到登录页
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      this.chooseActive = data; // 更新当前选中城市
      this.datalist = []; // 清空旧列表
      this.choose_page = 1; // 重置页码
      this.persistChooseData();
      this.getxuanfeilist(); // 请求新城市的人员列表
    },

    /**
     * 获取城市列表
     * 接口：address_list
     * 功能：获取城市数据 → 默认选中第一个
     */
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.addlist = this.normalizeAddressList(res.data);
        const hasCachedActive =
          this.chooseActive && this.chooseActive.id && this.addlist.some((item) => item.id === this.chooseActive.id);
        this.chooseActive = hasCachedActive
          ? this.addlist.find((item) => item.id === this.chooseActive.id)
          : (this.addlist[0] || {});
        this.persistChooseData();
        this.getxuanfeilist();
      });
    },
  },
  created() {
    // 页面初始化：加载城市列表
    this.applyCachedChooseData();
    this.getAddress();
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

/* 自定义颜色变量 */
@primary-orange: #F8A345;
@primary-yellow: #F5D387;
@primary-dark: #1A1A1A;
@primary-black: #000000;
@text-color: #E8D4B5;
@card-bg: rgba(30, 30, 30, 0.8);

::v-deep .van-image--round {
  border-radius: 1rem !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

::v-deep .van-pull-refresh{
  padding-bottom: 5rem;
  background: linear-gradient(to bottom, @primary-dark, @primary-black);
}

.bc-btn{
  width: 100%;
  height: auto;
  color: @primary-black;
  background: linear-gradient(135deg, @primary-orange, @primary-yellow);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0.5rem 0;
  border-radius: 0.8rem;
  box-shadow: 0 2px 8px rgba(248, 163, 69, 0.3);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(248, 163, 69, 0.5);
  }
}

.shoufei{
  font-size: 0.65rem;
  color: @text-color;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin: 0.3rem 0;
  p{
    margin-right: 0.5rem;
  }
}

.miaoshu {
  background: linear-gradient(135deg, @primary-orange, @primary-yellow);
  border-radius: 1rem;
  font-size: 0.5rem;
  padding: 0 0.4rem;
  height: 2.5vh;
  display: flex;
  align-items: center;
  color: @primary-black;
  font-weight: bold;
  p{
    font-size: 0.5rem;
  }
}

.bc-flex {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  .renzheng {
    display: flex;
    width: auto;
    height: 3vh;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    border: 1px solid @primary-orange;
    padding: 0.2rem 0.5rem;
    border-radius: 1rem;
    background: rgba(248, 163, 69, 0.1);
    div {
      font-size: 0.6rem;
      color: @primary-yellow;
    }
  }
  img {
    width: 0.7rem;
    margin-right: 0.3rem;
  }
}

/* 头部统计卡片样式 */
.bc-state {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 0.8rem;
  .state {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    background: linear-gradient(135deg, rgba(248, 163, 69, 0.2), rgba(245, 211, 135, 0.1));
    width: 48%;
    color: @text-color;
    font-size: 0.6rem;
    padding: 1rem 1rem 0.6rem 1rem;
    border-radius: 1rem;
    border: 1px solid rgba(248, 163, 69, 0.3);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
}

/* 热门标题区域样式 */
.bc-hot {
  color: @text-color;
  font-size: 1.3rem;
  padding: 1rem 1rem 0.5rem 0.5rem;
  background: rgba(0, 0, 0, 0.3);
  margin: 0 0.5rem;
  border-radius: 1rem 1rem 0 0;
}

.hot-title {
  color: @primary-yellow;
  font-weight: 500;
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
}

/* 头部整体背景卡片 */
.bc-top {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, @primary-dark, @primary-black);
  padding: 1rem 0.8rem;
  border: 1px solid rgba(248, 163, 69, 0.3);
  width: auto;
  margin: 0.8rem 0.5rem;
  border-radius: 1.2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.bc-top2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 0.5rem;
  border-radius: 1rem;
}

.font {
  color: @primary-black;
  font-weight: bold;
  font-size: 0.65rem;
  background: linear-gradient(135deg, @primary-orange, @primary-yellow);
  padding: 0.3rem 0.8rem;
  border-radius: 2rem;
  border: 1px solid @primary-yellow;
  width: auto;
  box-shadow: 0 2px 4px rgba(248, 163, 69, 0.3);
}

/* 加载更多按钮 */
.next {
  padding: @pd1;
  color: @primary-yellow;
  text-align: center;
  margin-bottom: 5rem;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 人员列表项样式 */
.movie-item {
  position: relative;
  margin: 1rem 0.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, @card-bg, rgba(20, 20, 20, 0.9));
  border: 1px solid rgba(248, 163, 69, 0.3);
  border-radius: 1.2rem;
  color: @text-color;
  display: flex;
  align-items: flex-start;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  }
}

.movie-img {
  width: 22vw;
  height: 25vw;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  /deep/ img {
    padding: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/* 横向地区标签样式 */
.address-tab-wrap {
  width: 100%;
  margin: 0 auto;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 0.8rem 0;
  scrollbar-width: none;
  background: rgba(0, 0, 0, 0.3);
  margin: 0 0.5rem;
  border-radius: 0 0 1rem 1rem;
  &::-webkit-scrollbar {
    display: none;
  }
}

.address-tab-item {
  padding: 0.4rem 1.2rem;
  margin: 0 0.5rem;
  font-size: 0.7rem;
  color: #666;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border-radius: 2rem;
  border: 1px solid rgba(248, 163, 69, 0.2);
  &.active {
    color: @primary-black;
    font-weight: bold;
    background: linear-gradient(135deg, @primary-orange, @primary-yellow);
    border-color: @primary-yellow;
    box-shadow: 0 2px 8px rgba(248, 163, 69, 0.3);
    &::after {
      display: none;
    }
  }
  &:hover {
    color: @primary-yellow;
    border-color: rgba(248, 163, 69, 0.5);
    background: rgba(248, 163, 69, 0.1);
  }
}

/* 页面全局布局 */
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to bottom, @primary-dark, @primary-black);
}

.convention-hall {
  display: flex;
  flex-direction: column;
  height: max-content;
}
</style>
